import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_NORM,
  DELETE_NORM,
  GET_NORMS,
  UPDATE_NORM,
  UPDATE_NORM_STATUS
} from "./actionTypes";

import {
  addNormFail,
  addNormSuccess,
  deleteNormFail,
  deleteNormSuccess,
  getNormsFail,
  getNormsSuccess,
  setState,
  updateNormFail,
  updateNormSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { norms, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchNorms({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, norms, params.toString());
    yield put(setState(false));
    yield put(getNormsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getNormsFail(error));
  }
}

function* updateNorm({ payload: normObj }) {
  try {
    const { id, recordStatus, ...rest } = normObj;
    yield call(patchApiCall, `${norms}/${id}`, rest);
    const response = yield call(getTable, `${norms}/${normObj.id}`);
    yield put(updateNormSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateNormFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateNormStatus({ payload: normObj }) {
  try {
    const { id } = normObj;
    yield call(patchApiCall, `${norms}/${updateStatus}/${id}`, { recordStatus: normObj.recordStatus });
    const response = yield call(getTable, `${norms}/${normObj.id}`);
    yield put(updateNormSuccess(response));
  } catch (error) {
    yield put(updateNormFail(error));
  }
}

function* deleteNorm({ payload: normObj }) {
  try {
    yield call(deleteApiCall, `${norms}/${normObj.id}`);
    yield put(deleteNormSuccess(normObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteNormFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingNorm({ payload: norm }) {
  try {
    const response = yield call(postApiCall, norms, norm);
    const response2 = yield call(getTable, `${norms}/${response.id}`);
    yield put(addNormSuccess(response2));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addNormFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* normsSaga() {
  yield takeEvery(GET_NORMS, fetchNorms);
  yield takeEvery(ADD_NEW_NORM, postingNorm);
  yield takeEvery(UPDATE_NORM, updateNorm);
  yield takeEvery(UPDATE_NORM_STATUS, updateNormStatus);
  yield takeEvery(DELETE_NORM, deleteNorm);
}

export default normsSaga;
